import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import peertopeerComponent from './peertopeer.component';
import formComponent from './component/form.component';
import successModalComponent from './component/success.modal.component';

import PeerToPeerStore from './service/peertopeer.store.js';

let peertopeerModule = angular.module('peertopeer', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('peertopeer', {
    parent: 'standardLayout',
    url: '/transactions/peer-to-peer',
    component: 'peertopeer'
  })
  ;
})

.component('peertopeer', peertopeerComponent)
.component('productForm', formComponent)
.component('p2pSuccessModal', successModalComponent)
.service('PeerToPeerStore', PeerToPeerStore)
.name;

export default peertopeerModule;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/peertopeer.js